<template>
  <div class="list-box common-shadow clearfix">
    <vxe-table
        class="table-style"
        stripe
        highlight-hover-row
        show-footer
        show-overflow
        auto-resize
        border="none"
        :data="detailInfo"
        align="center"
    >
      <vxe-table-column field="chainNum" title="主订单编号"></vxe-table-column>
      <vxe-table-column field="platformCompany" title="平台企业"></vxe-table-column>
      <vxe-table-column field="isComplete" title="订单状态">
        <template v-slot="{row}">
          {{ row.isComplete == 1 ? '已完成' : '执行中' }}
        </template>
      </vxe-table-column>
      <vxe-table-column field="salesManName" title="业务员"></vxe-table-column>
      <vxe-table-column field="createUser" title="客户经理"></vxe-table-column>
      <vxe-table-column field="salesManageName" title="销售经理"></vxe-table-column>
      <vxe-table-column field="createTime" title="创建时间" v-if="isHavePermission('global:viewCreateTime')">
        <template slot-scope="{ row }">
          <span>{{ row.createTime | timeFormatDate }}</span>
        </template>
      </vxe-table-column>
    </vxe-table>

    <Modal
        v-model="errModal"
        :cancelText="''"
        title="校验提示" >
        <div  v-for="(item,i) in errList"  v-bind:key="i">
          {{item}}
        </div>
    </Modal>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import getAuthOrization from "@/mixin/getAuthOrization";
import {apiPost} from "../../../utils/api";

export default {
  props: {
    detailInfo: Array,
  },
  mixins: [getAuthOrization],
  data() {
    return {
      errModal: false,
      errList: []
    }
  },
  methods: {
    async showUpdateChainStatus() {
      let detail = this.detailInfo[0]
      let updateStatus = detail.isComplete == 1 ? '执行中' : "已完成"
      let confirmRes = await this.$XModal.confirm(
          "是否将状态更新为" + updateStatus,
          "状态更新"
      );
      if (confirmRes === "confirm") {
        let res = await apiPost("api/order/", 'ordersSeller/updateChainStatus', {
          id: detail.id
        });
        if (res.status === 1) {
          detail.isComplete = detail.isComplete == 1 ? 0 : 1;
          this.$XModal.message({message: `状态更新成功！`});
        } else {
          this.errList = res.data
          this.errModal = true
        }
      }
    }
  }
};
</script>

<style>
</style>